export const recipeData = [
  {
    id: 1,
    chefName: "Chef Ajay Chopra",
    chefInstaId: "@chefajaychopra",
    chefInstaIdLink: "https://www.instagram.com/chefajaychopra/",
    recipeName: "Dill & Spinach Omelette",
    recipeLinkText:
      "Dill & Spinach Omelette with herbed yogurt crostini + cherry tomatoes, light, protein-packed, full of flavour.",
    recipeLink: "https://www.instagram.com/reel/DQrkefMCIHK/",
  },
  {
    id: 2,
    chefName: "Chef Ajay Chopra",
    chefInstaId: "@chefajaychopra",
    chefInstaIdLink: "https://www.instagram.com/chefajaychopra/",
    recipeName: "Avocado Toastie",
    recipeLinkText:
      "Avocado Toastie, creamy avo on crisp toast, juicy tomatoes, chia crunch and that perfectly runny poached egg. 10 minutes, clean, and loaded with good fats + protein.",
    recipeLink: "https://www.instagram.com/reel/DQgXGuHiHmP/",
  },
  {
    id: 3,
    chefName: "Chef Ajay Chopra",
    chefInstaId: "@chefajaychopra",
    chefInstaIdLink: "https://www.instagram.com/chefajaychopra/",
    recipeName: "Lauki Chila",
    recipeLinkText:
      "Lauki never looked this good! Crispy, wholesome and full of flavour, this Lauki Chila is your go-to for a quick, healthy meal that doesn't compromise on taste.",
    recipeLink: "https://www.instagram.com/reel/DPquZE_iCJJ/",
  },
];
